// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24.0029 12.0001L0.291992 1.66455L3.58686 11H11.0005V13H3.5869L0.291992 22.3356L24.0029 12.0001Z"}}]};

const SendFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'send-filled',
    ref,
    icon: element,
  },
));

SendFilledIcon.displayName = 'SendFilledIcon';

export default SendFilledIcon;
